export const messages = {
  ru: {
    title: 'Темплейт фронтенда',
    notFound: 'Страница не найдена',
    home: {
      info: "aaa"
    }
  },
  en: {
    title: 'Frontend template',
    notFound: 'Page not found',
    home: {
      info: "bbb"
    }
  },
  fr: {
    title: 'Frontend template',
    notFound: 'Page not found',
    home: {
      title: "La Russie, peut-elle atteindre le niveau du Canada dans le domaine d’énergie durable?"
    }
  },
}
